export const activityTypes = {
  song: 'song',
  video: 'video',
  craft: 'craft',
  pictureDictionary: 'pictureDictionary',
  interactiveVideo: 'interactiveVideo',
  game: 'game',
  worksheet: 'worksheet',
  realTime: 'realTime',
  comic: 'comic',
  storyWithQuestions: 'storyWithQuestions',
  songQuestions: 'songQuestions',
  reinforcement: 'reinforcement',
  external: 'external',
};
